import KibanaFilterModel from './osd-filter-model';
export default class LuceneFilterModel extends KibanaFilterModel {
    meta;
    query_string;
    constructor(meta) {
        super(meta);
        this.meta = meta;
        this.query_string = { query: meta.key };
    }
}
//# sourceMappingURL=lucene-filter-model.js.map